<template>
  <div>
    <form
      ref="form"
      action="/j_spring_security_check"
      :class="{'opacity-50': isWorking}"
      autocomplete="on"
      method="post"
      @submit.prevent="submit"
    >
      <fieldset>
        <legend v-if="!viewBreakpointIs('small')" class="text-lg font-semibold mb-2">{{ $t('login.title') }}</legend>
        <pdl-callout v-if="hasErrorMessage" kind="error">
          <template #content>
            <p v-for="(errorMessage, index) in errorMessages" :key="index" class="mb-1" v-html="$t(errorMessage)" />
          </template>
        </pdl-callout>
        <pdl-form-group
          v-model="email"
          type="email"
          name="j_username"
          autocomplete="email"
          :label="$t('login.email')"
          :error="getErrorMessage('email')"
        />
        <pdl-form-group
          v-model="password"
          type="password"
          name="j_password"
          autocomplete="current-password"
          :label="$t('login.password')"
          :error="getErrorMessage('password')"
        />
        <pdl-form-group
          type="checkbox"
          name="_spring_security_remember_me"
          :multi-items="[{displayName: $t('login.remember'), checked: rememberMe, value: true}]"
          qaid="login-remember-me"
          @change="
            (e) => {
              rememberMe = e.target.checked;
            }
          "
        />

        <trek-button primary :disabled="isWorking" type="submit" class="mb-4">
          <span>{{ $t('login.login') }}</span>
        </trek-button>
      </fieldset>
    </form>
    <pdl-link small standalone :href="withContextPath('/login/pw/request/external/')">
      {{ $t('forgottenPwd.title') }}
    </pdl-link>
  </div>
</template>
<script>
import {Url} from '@/utils/url';
import {PdlCallout} from '@pedal/pdl-callout';
import {PdlLink} from '@pedal/pdl-link';
import {PdlFormGroup} from '@pedal/pdl-form-group';
import TrekButton from '@/components/TrekButton';
import {UserAccountBase} from '@/components/containers/my-account/utils/user-account-base.js';
import {TrekValidationMixin} from '@/utils/validation/trek-validation-mixin';
import {mapGetters} from 'vuex';

export default {
  name: 'UserLogin',
  components: {PdlCallout, PdlLink, TrekButton, PdlFormGroup},
  extends: UserAccountBase,
  mixins: [TrekValidationMixin],
  props: {
    options: {
      type: Object,
      required: true,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {
      ...TrekValidationMixin.setup(),
      ...UserAccountBase.setup(),
    };
  },
  data() {
    return {
      isWorking: false,
      rememberMe: false,
      email: '',
      password: '',
      hasErrorCallout: false,
    };
  },
  validations() {
    return {
      email: {
        required: this.trekValidators.required('login.email'),
        email: this.trekValidators.email('login.email'),
      },
      password: {
        required: this.trekValidators.required('login.password'),
      },
    };
  },
  computed: {
    ...mapGetters('viewSize', ['viewBreakpointIs']),
    hasErrorMessage() {
      return !!this.errorMessages?.length > 0;
    },
  },

  methods: {
    withContextPath: (url) => Url.withContextPath(url),

    /**
     * Handle form submission & validate data.
     * @return {Promise<void>}
     */
    submit() {
      this.hasErrorCallout = false;
      this.v$.$validate().then((isValid) => {
        if (isValid) {
          this.isWorking = true;
          this.$refs.form.submit();
        }
      });
    },
  },
};
</script>
